export default __webpack_public_path__ + "static/connected-sensors-mobile.hevc-d7ec1254e39cbb911a50816d7e778762.mp4";